import type { CityConfig } from "../city-template/types";

export const goldsboroConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Goldsboro",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "goldsboro",
  route: "/goldsboro",
  title: "Emergency Passport Goldsboro, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Goldsboro, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Wayne County, Seymour Johnson AFB, and military families. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Goldsboro, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Goldsboro and Wayne County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Goldsboro%20North%20Carolina%20cityscape%20at%20golden%20hour%20with%20charming%20downtown%20historic%20district%2C%20renovated%20brick%20buildings%20and%20tree-lined%20streets%2C%20Seymour%20Johnson%20Air%20Force%20Base%20visible%20in%20the%20distant%20background%2C%20lush%20green%20trees%20of%20the%20eastern%20North%20Carolina%20flatlands%2C%20warm%20sunset%20light%20over%20Wayne%20County%2C%20clean%20sky%20with%20soft%20clouds%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20military%20town%20southern%20charm%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=goldsboro-hero-nc-001&orientation=landscape",
  heroImageAlt: "Goldsboro North Carolina downtown historic district at golden hour with Wayne County flatlands",
  geoPosition: "35.3849;-77.9928",
  geoPlacename: "Goldsboro, North Carolina",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 300 miles north of Goldsboro — about 5 hours via I-95",
  },
  nearbyCitiesZips: [
    { name: "Goldsboro", zips: "27530, 27531, 27532, 27533, 27534" },
    { name: "Mount Olive", zips: "28365" },
    { name: "Pikeville", zips: "27863" },
    { name: "Fremont", zips: "27830" },
    { name: "La Grange", zips: "28551" },
    { name: "Snow Hill", zips: "28580" },
    { name: "Warsaw", zips: "28398" },
    { name: "Kinston", zips: "28501, 28502, 28503, 28504" },
    { name: "Greenville", zips: "27834, 27835, 27836, 27858" },
    { name: "Wilson", zips: "27893, 27894, 27895, 27896" },
    { name: "Rocky Mount", zips: "27801, 27802, 27803, 27804" },
    { name: "Raleigh", zips: "27601–27699" },
    { name: "Smithfield", zips: "27577" },
    { name: "Clayton", zips: "27520, 27527, 27528" },
    { name: "New Bern", zips: "28560, 28561, 28562, 28563, 28564" },
    { name: "Jacksonville", zips: "28540, 28541, 28542, 28543, 28544, 28545, 28546, 28547" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Wayne County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Wayne County Hub", desc: "Serving Goldsboro, Seymour Johnson AFB, and military families" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Raleigh, NC", route: "/raleigh" },
    { name: "Fast passport renewal in Fayetteville, NC", route: "/fayetteville" },
    { name: "Emergency passport help in Jacksonville, NC", route: "/jacksonville-nc" },
    { name: "Urgent passport services in Greenville, NC", route: "/greenville" },
    { name: "Passport courier services in Durham, NC", route: "/durham" },
    { name: "Same-day passport help in Rocky Mount, NC", route: "/rocky-mount" },
    { name: "Fast passport renewal in Wilson, NC", route: "/wilson" },
    { name: "Emergency passport help in New Bern, NC", route: "/new-bern" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Goldsboro remotely via secure courier. We do not have a walk-in office in Goldsboro — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Wayne County and military families.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Wayne County and surrounding eastern North Carolina",
  serviceAreaIntro: "From downtown Goldsboro's historic district to the Seymour Johnson Air Force Base community, from the Mount Olive suburbs to the rural communities of Pikeville, Fremont, and La Grange — Fast Passport Center serves the entire Goldsboro region. We regularly help travelers from Kinston, Greenville, Wilson, Rocky Mount, Raleigh, and Smithfield get their passports fast.",
  nearbyCitiesIntro: "We serve all Goldsboro neighborhoods and the surrounding Wayne County area including Mount Olive, Pikeville, Fremont, La Grange, Snow Hill, Warsaw, Kinston, Greenville, Wilson, Rocky Mount, Raleigh, Smithfield, Clayton, New Bern, and Jacksonville. If you are anywhere in Wayne County or eastern North Carolina, we have you covered.",
  howItWorksIntro: "Most Goldsboro travelers complete everything online and ship documents overnight. No need to drive to Washington DC or wait in line at the regional agency.",
  mistakesIntro: "Goldsboro travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Goldsboro and Wayne County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Goldsboro? Here are the most common ones we hear from Wayne County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Goldsboro international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Sgt. Michael R.",
      location: "Seymour Johnson AFB, NC",
      rating: 5,
      text: "Military deployment orders came through with 4 days notice. Fast Passport Center had my emergency passport ready in 26 hours. They understand the urgency military families face. Outstanding support.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer L.",
      location: "Goldsboro, NC",
      rating: 5,
      text: "My passport expired the week before a family trip to the Dominican Republic. Fast Passport Center had my renewal in 3 days. I didn't have to drive to Atlanta or take time off work.",
      service: "Passport Renewal",
    },
    {
      name: "Amanda T.",
      location: "Mount Olive, NC",
      rating: 5,
      text: "First passports for my twin 10-year-olds before a spring break trip to Cancun. Fast Passport Center walked us through every parent consent form. Had both passports in 6 days. Stress-free experience.",
      service: "Child Passport",
    },
    {
      name: "Chris D.",
      location: "Pikeville, NC",
      rating: 5,
      text: "Lost my passport 3 days before a business trip to Germany. Fast Passport Center had a replacement in 28 hours. They saved my career and my trip. Best service in Wayne County.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "goldsboro-1",
      name: "Goldsboro Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "210 N Center St",
      city: "Goldsboro",
      state: "NC",
      zip: "27530",
      phone: "(919) 735-4181",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Goldsboro",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Goldsboro facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "goldsboro-2",
      name: "Mount Olive Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "107 W College St",
      city: "Mount Olive",
      state: "NC",
      zip: "28365",
      phone: "(919) 658-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles south of Goldsboro",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Mount Olive and southern Wayne County residents. Less crowded than Goldsboro. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "goldsboro-3",
      name: "Smithfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "221 E Market St",
      city: "Smithfield",
      state: "NC",
      zip: "27577",
      phone: "(919) 934-4181",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles north of Goldsboro",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Johnston County and northern Wayne County. Alternative for Goldsboro north side residents.",
      icon: "ri-mail-line",
    },
    {
      id: "goldsboro-4",
      name: "Kinston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "301 N Queen St",
      city: "Kinston",
      state: "NC",
      zip: "28501",
      phone: "(252) 523-2101",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles east of Goldsboro",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lenoir County and eastern Wayne County. Alternative for Goldsboro east side residents.",
      icon: "ri-mail-line",
    },
    {
      id: "goldsboro-5",
      name: "Wayne County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "224 E Walnut St",
      city: "Goldsboro",
      state: "NC",
      zip: "27530",
      phone: "(919) 731-1449",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Goldsboro, Courthouse",
      website: "https://www.waynegov.com/",
      websiteLabel: "Wayne County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "goldsboro-6",
      name: "Raleigh Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3800 S Halifax Rd",
      city: "Raleigh",
      state: "NC",
      zip: "27604",
      phone: "(919) 850-9101",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "55 miles northwest of Goldsboro",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Wake County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Washington DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Goldsboro photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Wayne County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Goldsboro applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Wayne County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Goldsboro travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Goldsboro." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Goldsboro address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Goldsboro before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Goldsboro for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5 hour drive to Washington DC." },
    { q: "How fast can I renew my passport in Goldsboro?", a: "Fast Passport Center offers fast passport renewal in Goldsboro in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Goldsboro?", a: "The nearest regional passport agency to Goldsboro is the Washington DC Passport Agency at 600 19th St NW, Washington DC 20006, approximately 300 miles north via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Goldsboro without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Goldsboro?", a: "Same-day passport appointments are only available at the Washington DC Passport Agency — approximately 5 hours from Goldsboro — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Wayne County residents." },
    { q: "Do you serve military families at Seymour Johnson AFB?", a: "Absolutely. Fast Passport Center serves military families at Seymour Johnson Air Force Base and throughout Wayne County. We understand the unique urgency of military travel and deployment orders. Our emergency courier service can process passports in 24–48 hours for Goldsboro area service members and their families." },
    { q: "Can I expedite a child passport in Goldsboro?", a: "Yes. Fast Passport Center expedites child passports in Goldsboro for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Wayne County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Goldsboro with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Washington DC Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Goldsboro", address: "1806 N Berkeley Blvd, Goldsboro, NC 27534", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Goldsboro", address: "2003 E Ash St, Goldsboro, NC 27530", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Goldsboro", address: "2840 E Ash St, Goldsboro, NC 27534", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Mount Olive", address: "1010 N Breazeale Ave, Mount Olive, NC 28365", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Wilson", address: "301 Raleigh Rd Pkwy W, Wilson, NC 27896", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart — Wilson", address: "2915 Raleigh Rd Pkwy W, Wilson, NC 27896", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Kinston", address: "4100 W Vernon Ave, Kinston, NC 28504", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Rocky Mount", address: "1200 S Wesleyan Blvd, Rocky Mount, NC 27803", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Goldsboro",
      address: "2133 E Ash St, Goldsboro, NC 27530",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Raleigh South",
      address: "8301 Old Stage Rd, Raleigh, NC 27603",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Wilson",
      address: "2915 Raleigh Rd Pkwy W, Wilson, NC 27896",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Wilson County. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Kinston",
      address: "2602 W Vernon Ave, Kinston, NC 28504",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Lenoir County. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "70 miles northwest of Goldsboro",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international hub with direct flights to Europe, Canada, Mexico, and the Caribbean. The closest major airport for Goldsboro travelers.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: true,
    },
    {
      code: "GSB",
      name: "Seymour Johnson Air Force Base",
      distance: "5 miles north of Goldsboro",
      address: "1781 E Seymour Johnson Ave, Goldsboro, NC 27531",
      note: "Military airbase with limited civilian access. Military flights available for active duty personnel.",
      flightUrl: "https://www.seymourjohnson.af.mil/",
      flightLabel: "Seymour Johnson AFB",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "180 miles west of Goldsboro",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "American Airlines hub with the most international flight options from North Carolina. Consider for long-haul international travel.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Wayne County Register of Deeds',
      description: 'Marriage licenses and records for Wayne County. Apply in person or request certified copies.',
      url: 'https://www.waynegov.com/282/Register-of-Deeds',
    },
    {
      label: 'Wayne County Clerk of Superior Court',
      description: 'Divorce records and decrees for Wayne County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/wayne-county/wayne-county-clerk-of-superior-court',
    },
  ],
};